import { render } from "./RegisterFromInvite.vue?vue&type=template&id=228f7241"
import script from "./RegisterFromInvite.vue?vue&type=script&lang=js"
export * from "./RegisterFromInvite.vue?vue&type=script&lang=js"
script.render = render

export default script